import { COMMUNICATION_CONTENT_VISIBLE, SET_COMMUNICATION_CONTENT } from '../actions/types'

export const communication = (
  state = {
    visible: false,
    notification: null,
  },
  { type, payload }
) => {
  if (type === COMMUNICATION_CONTENT_VISIBLE) {
    return { ...state, visible: payload }
  }
  if (type === SET_COMMUNICATION_CONTENT) {
    return { ...state, ...payload }
  }
  return state
}
